<template>
<MainViewFrame>
  <div class="myFollower">
    <div class="headView">
      <span class="text">{{type === 'fan' ? "粉丝 ":"关注 "}}{{total_count}}</span>
    </div>

    <div class="members">
      <template v-if="type === 'fan'">
      <div class="member" v-for="(item, index) in data" :key="item.pk" @click="jumpToProfile(item.owner)">
        <img
          class="avatar"
          :src="getImg(item.owner.avatar)"
          alt=""
        />
        <div class="rightView">
          <span class="name">{{item.owner.name}}</span>
          <span class="btn unselect" v-if="item.is_follow_owner" @click.stop="followEvent(item.owner.user, 'cancel', item)">取消关注</span>
          <span class="btn" v-else @click.stop="followEvent(item.owner.user, 'add', item)">+ 关注</span>
        </div>
      </div>
      </template>

      <template v-else>
      <div class="member" v-for="(item, index) in data" :key="item.pk" @click="jumpToProfile(item.follower)">
        <img
          class="avatar"
          :src="getImg(item.follower.avatar)"
          alt=""
        />
        <div class="rightView">
          <span class="name">{{item.follower.name}}</span>
          <span class="btn unselect" v-if="item.is_follow_follower" @click.stop="followEvent(item.follower.user, 'cancel', item)">取消关注</span>
          <span class="btn" v-else @click.stop="followEvent(item.follower.user, 'add', item)">+ 关注</span>
          <div v-if="ownerInfo.is_staff">
          <span class="btn unselect btn1" v-if="item.is_my_student" @click.stop="myStudentEvent(item)">取消成为我的学生</span>
          <span class="btn btn1" v-else @click.stop="myStudentEvent(item)">成为我的学生</span>
          </div>
        </div>
      </div>
      </template>
    </div>
   
  </div>
</MainViewFrame>
</template>

<script>
// @ is an alias to /src
import { Utils } from "../utils";
import MainViewFrame from "./MainViewFrame.vue";

import { types as ToastTypes } from "../store/modules/toast";
import { types as LoginTypes } from "../store/modules/login";
import { types as MyFollowerTypes } from "../store/modules/myfollower";
import { types as CommunityTypes } from "../store/modules/community";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "MyFollower",
  components: {
    MainViewFrame,
  },
  props: {
  },
  data() {
    return {
      type:"follow"
    };
  },
  watch: {},
  computed: {
    ...mapState({
        ownerInfo: state => state.login.userInfo,
        total_count: state => state.myfollower.total_count,
        page: state => state.myfollower.page,
        load_more: state => state.myfollower.load_more,
        data: state => state.myfollower.data,
    }),
    ...mapGetters({
    })
  },
  methods: {
    ...mapMutations({
      showToast: ToastTypes.SHOW,
      loadFollowEvent: MyFollowerTypes.DEAL_FOLLOW_EVENT
    }),
    ...mapActions({
        fetchOwnInfo: LoginTypes.FETCH_USERINFO,
        fetchListData: MyFollowerTypes.FETCH_LIST_DATA,
        fetchFollowEvent: CommunityTypes.FETCH_FOLLOWERS_EVENT,
        fetchMyStudentEvent: MyFollowerTypes.FETCH_IS_MY_STUDENT
    }),
    ...Utils,

    //跳到个人主页
    jumpToProfile(item){
      let user_id = item.user_id;
      this.$router.push(`/profile/${user_id}`);
    },
    // 关注、取关事件
    followEvent(username, tag, item){
      // {"type":"post", "is_follow":true, "followers":["15201052252"]}
      if(this.type === 'fan'){
        // 粉丝列表
        if(item.follower.user === this.ownerInfo.owner){
          // 处理按钮状态
          let dic = {"followers":[item.owner.user], "is_follow":item.is_follow_owner}
          this.fetchFollowEvent(dic);
          // 处理当前页面的关注/取关按钮状态
          let temp_dic = {"type":this.type, "user":item.owner.user}
          this.loadFollowEvent(temp_dic)
        }else{
          // 提示文字
          let message = ""
          if(item.is_follow_owner){
            message = "取关成功"
          }else{
            message = "关注成功"
          }
          this.showToast({message:message})
        }
      }else {
        // 关注列表
        if(item.owner.user === this.ownerInfo.owner){
          // 处理按钮状态
          let dic = {"followers":[item.follower.user], "is_follow":item.is_follow_follower}
          this.fetchFollowEvent(dic);
          // 处理当前页面的关注/取关按钮状态
          let temp_dic = {"type":this.type, "user":item.follower.user}
          this.loadFollowEvent(temp_dic)
        }else{
          // 提示文字
          let message = ""
          if(item.is_follow_follower){
            message = "取关成功"
          }else{
            message = "关注成功"
          }
          this.showToast({message:message})
        }
      }

    },
    // 成为我的学生/取消
    myStudentEvent(item){
      let user_id = item.follower.user_id
      this.fetchMyStudentEvent({"user_id":user_id})
    },
    handleScroll(e) {
      var that = this;
      let height = document.body.clientHeight;
      let scrollHeight = document.body.scrollHeight;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      
      // if(e && e.target){
      //   height = e.target.offsetHeight
      //   scrollHeight = e.target.scrollHeight
      //   scrollTop = e.target.scrollTop
      // }
      
      // console.log("帖子列表:", height, scrollHeight, scrollTop);
      if (scrollHeight <= height + scrollTop + 50) {
        if (that.load_more) {
          // console.log("还有更多数据，到达底部，继续加载新数据(帖子)");
          if(that.user_id){
            that.fetchListData({page:1, type:that.type, user_id:that.user_id})
          }else{
            that.fetchListData({page:that.page+1, type:that.type})
          }
        } else {
          // console.log("没有新数据了");
        }
      } else {
        // console.log("没到底部");
      }
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted() {
    this.fetchOwnInfo();
    let type = "follow"
    if (this.$route.query.type) {
      type = this.$route.query.type;
    }
    this.type = type;
    if (this.$route.query.userid) {
      this.user_id = this.$route.query.userid
      this.fetchListData({page:1, type:this.type, user_id:this.user_id})
    }else{
      this.fetchListData({page:1, type:this.type})
    }
  }
};
</script>

<style lang="less" scoped>
.myFollower {
  background-color: #f6f6f6;
  padding: 15px;
  min-height: 350px;
  border-radius: 5px;
  .headView {
    margin-bottom: 15px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .text {
      color: #666666;
      font-size: 13px;
    }
  }
  .members {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: calc(100%);
    margin: auto;
    margin-left: 5px;
    .member {
      background-color: #ffffff;
      border: solid 1px #f56501;
      margin-right: 10px;
      margin-bottom: 10px;
      padding: 10px;
      cursor: pointer;
      border-radius: 8px;
      overflow: hidden;
      width: 170px;
      width: calc(100% / 4 - 12px - 20px);
      display: flex;
      flex-direction: row;
      align-items: center;
      position: relative;
      color: #333333;
      .avatar {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        margin-right: 15px;
        display: inline-block;
      }
      .rightView{
        flex: 1;
        display: flex;
        flex-direction: column;
      }
      .name {
        font-size: 13px;
        height: 20px;
        overflow: hidden;
        line-height: 20px;
      }
      .btn{
        background-color: #ff6600;
        font-size: 11px;
        width: 60px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        margin-top: 5px;
        border-radius: 3px;
        color: #ffffff;
        cursor: pointer;
        &.unselect{
          background: linear-gradient(to bottom, #696e78 0%,#646973 100%);
        }
      }
      .btn1{
        padding: 2px 4px;
        margin-top: 5px;
        display: inline-flex;
        width: initial;
      }
    }
  }
}
</style>
